<template>
  <div>
    <v-container grid-list-lg fluid fill-height>
      <v-layout row wrap>
        <v-flex d-flex xs12 md4>
          <TicketStatus />
        </v-flex>
        <v-flex d-flex xs12 md4>
          <TicketByUser />
        </v-flex>
        <v-flex d-flex xs12 md4>
          <Feedback />
        </v-flex>
        <v-flex xs12>
          <v-tabs fixed-tabs v-model="active" slider-color="info">
            <v-tab class="text-transform-none">{{ $t("labels.your") }}</v-tab>
            <v-tab
              class="text-transform-none"
              v-if="currentUser.accountTypeID !== 6 && currentUser.accountTypeID !== 5"
              >{{ $t("labels.all") }}</v-tab
            >
            <v-tabs-items touchless>
              <v-tab-item>
                <DueTickets />
              </v-tab-item>
              <v-tab-item>
                <AllUserTicket />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import TicketStatus from "../components/TicketStatus";
import TicketByUser from "../components/TicketByUser";
import DueTickets from "../components/DueTickets";
import AllUserTicket from "../components/AllUserTicket";
import Feedback from "../components/Feedback";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      active: null
    }
  },
  computed: {
    ...mapGetters("global", ["currentUser"])
  },
  components: {
    TicketStatus,
    TicketByUser,
    DueTickets,
    Feedback,
    AllUserTicket
  }
};
</script>

<style scoped></style>
